/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Lot_Trace_Field_Quantity_KgInputs */

const vi_order_lot_trace_field_quantity_kg = /** @type {(inputs: Order_Lot_Trace_Field_Quantity_KgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KL`)
};

/**

* @param {Order_Lot_Trace_Field_Quantity_KgInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_lot_trace_field_quantity_kg = /** @type {((inputs?: Order_Lot_Trace_Field_Quantity_KgInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Lot_Trace_Field_Quantity_KgInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_lot_trace_field_quantity_kg(inputs)
});